import React from "react";
import { CButton, CCol, CRow } from "@coreui/react";
import DebitNoteItemForm from "../DebitNoteItemForm";
import { useDebitNoteFormContext } from "../context/DebitNoteFormContext";
import { extractArrayErrors } from "../../../models/errors";

const SectionDivider: React.FC<{ icon: string; label: string; badge?: number }> = ({ icon, label, badge }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    {badge !== undefined && (
      <span
        style={{
          marginLeft: "8px",
          background: "#006657",
          color: "white",
          borderRadius: "10px",
          padding: "1px 8px",
          fontSize: "0.7rem",
          fontWeight: 700,
        }}
      >
        {badge}
      </span>
    )}
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

export const DebitNoteFormItems: React.FC = () => {
  const {
    items,
    currency,
    client,
    onItemChange,
    onItemDelete,
    onAddItemClick,
    errors,
  } = useDebitNoteFormContext();

  const itemErrors = extractArrayErrors("items", errors);

  return (
    <>
      <SectionDivider icon="fa-list" label="Ítems" badge={items.length} />
      {items.map((item, ix) => (
        <CRow key={ix}>
          <CCol>
            <DebitNoteItemForm
              currency={currency}
              item={item}
              client={client}
              onDelete={() => onItemDelete(ix)}
              onChange={(item) => onItemChange(ix, item)}
              errors={ix < itemErrors.length ? itemErrors[ix] : {}}
            />
          </CCol>
        </CRow>
      ))}
      <CRow className="mt-3">
        <CCol className="d-flex justify-content-end">
          <CButton
            color="primary"
            variant="outline"
            onClick={onAddItemClick}
            style={{ fontWeight: 600, padding: "7px 18px" }}
          >
            <i className="fa fa-plus mr-2"></i>
            Agregar Ítem
          </CButton>
        </CCol>
      </CRow>
    </>
  );
};
